export default function Footer() {
  return (
    <footer className="bg-stem-dark py-6 md:py-8">
      <div className="section-padding max-w-6xl mx-auto text-center">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-xs md:text-sm text-stem-lightgray">
          <p>
            &copy; {new Date().getFullYear()} Ahmad Danial Portfolio. All rights
            reserved.
          </p>
          <span className="hidden sm:inline text-stem-gray">&middot;</span>
          <p className="text-stem-gray">Made with curiosity and code.</p>
        </div>
      </div>
    </footer>
  );
}
